(function () {
    'use strict';

    angular
        .module('elogbooks.admin.regions')
        .controller('RegionsController', RegionsController);

    RegionsController.$inject = ['$state', '$stateParams', '$filter', 'regionCollectionResponse'];

    function RegionsController ($state, $stateParams, $filter, regionCollectionResponse) {
        var vm = this;
            vm.regions = regionCollectionResponse.regions;
            vm.regionCollectionResponse = regionCollectionResponse;

        vm.order = order;
        vm.search = search;

        var activeOptions = [
            {
                title: $filter('translate')('NONE_SELECTED'),
                value: null
            },
            {
                title: $filter('translate')('STATUS_ACTIVE'),
                value: 'true'
            },
            {
                title: $filter('translate')('STATUS_INACTIVE'),
                value: 'false'
            }
        ];

        vm.criteria = {
            id: { type: 'number', value: $stateParams.id ? parseInt($stateParams.id, 10) : null, title: 'ID', min: 1 },
            name: { type: 'text', value: $stateParams.name, title: 'NAME' },
            active: { type: 'options', title: 'IS_ACTIVE', value: $stateParams.active, options: activeOptions }
        };

        function order (key) {
            $stateParams.order = key;

            $state.go('.', angular.extend({}, $stateParams), { reload: true });
        }

        function search (params) {
            var override = {
                page: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: true });
        }
    }
})();
